import React, { useCallback } from 'react';
import { dailyRandom, useDraft } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { useSubmitter } from '../../platform/Hook';
import { ResultInfoForSubmitter } from '../../ui/ResultInfo';
import { useResolve } from '../Container';
import { Copy, Spacer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { Button, Input, Prompt } from './../../ui';
import { folderCreate } from './FolderCommands';

const placeholders = [
    'e.g. Boards n\' stuff',
    'e.g. My Folder',
    'e.g. Team Boards',
    'e.g. Dope Boards',
    'e.g. Just a folder',
    'e.g. Archive',
    'e.g. Planning',
    'e.g. Retros',
    'e.g. Estimation',
    'e.g. Planning',
    'e.g. Retros',
    'e.g. Estimation',
    'e.g. Planning',
    'e.g. Retros',
    'e.g. Estimation',
];

export const createFolderPopup = (workspaceId?: string) => ({ ui: CreateFolderPopup, args: { workspaceId } });

export const CreateFolderPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {

    const dispatch = useResolve(CommandDispatcher);
    const [draft, patchDraft] = useDraft({
        label: '',
        description: '',
    });

    const invalid = !draft.label.trim();

    const [onCreate, working, result] = useSubmitter(async () => {
        action(await dispatch(folderCreate, [args.workspaceId, draft.label]));
    }, [args, draft]);

    const onPromptAction = useCallback((confirm: boolean) => {
        if (!confirm) dismiss();
        else if (!invalid) onCreate();
    }, [invalid, onCreate]);

    return <Prompt onAction={working ? null : onPromptAction}>
        <Popup w={32}>
            <Popup.Close onAction={() => onPromptAction(false)} />
            <Popup.Title>Create Folder</Popup.Title>
            <Popup.Content>
                <Copy>
                    Folders are a way of further organizing your boards within a workspace.  If you have a lot of boards,
                    you can use folders to further group them together.
                </Copy>
                <Spacer f={2} />
                <Input
                    label="Name"
                    placeholder={dailyRandom(placeholders)}
                    autoFocus
                    value={draft.label}
                    onChange={x => patchDraft({ label: x })}
                />
                <Spacer f={2} />
                <ResultInfoForSubmitter result={result} />
            </Popup.Content>
            <Popup.Actions>
                <Button disabled={invalid || working} variant="primary" onAction={onCreate}>
                    {working ? 'Creating...' : 'Create'}
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
